import { cn } from '../utilities.ts'
import { IconProps, IconType } from './types.ts'

export const TrashCanIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-trash', type, className)}></i>
}

export const ViewIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-eye', type, className)}></i>
}

export const EditIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-notepad-edit', type, className)}></i>
}
export const EyeIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-eye', type, className)}></i>
}

export const KebabMenuIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-dots-vertical', type, className)}></i>
}

export const EyeSlashIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-eye-slash', type, className)}></i>
}

export const ProfileCircleIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn(`ki-profile-circle`, type, className)}></i>
}

export const ImagePlaceHolderIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-picture', type, className)}></i>
}

export const CalendarIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-calendar', type, className)} />
}

export const MagnifierIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-magnifier', type, className)}></i>
}

export const FilterIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-filter', type, className)}></i>
}

export const StarIcon = ({ type = IconType.Solid, className }: IconProps) => {
  return <i className={cn('ki-star', type, className)}></i>
}

export const GeneralIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-icon', type, className)}></i>
}

export const VerifiedBadgeSVG = ({ className }: Omit<IconProps, 'type'>) => {
  return (
    <svg
      className={className}
      fill="none"
      height="16"
      viewBox="0 0 15 16"
      width="15"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5425 6.89749L13.5 5.83999C13.4273 5.76877 13.3699 5.6835 13.3312 5.58937C13.2925 5.49525 13.2734 5.39424 13.275 5.29249V3.79249C13.274 3.58699 13.2324 3.38371 13.1527 3.19432C13.0729 3.00494 12.9565 2.83318 12.8101 2.68892C12.6638 2.54466 12.4904 2.43073 12.2998 2.35369C12.1093 2.27665 11.9055 2.23801 11.7 2.23999H10.2C10.0982 2.24159 9.99722 2.22247 9.9031 2.18378C9.80898 2.1451 9.72371 2.08767 9.65249 2.01499L8.60249 0.957487C8.30998 0.665289 7.91344 0.50116 7.49999 0.50116C7.08654 0.50116 6.68999 0.665289 6.39749 0.957487L5.33999 1.99999C5.26876 2.07267 5.1835 2.1301 5.08937 2.16879C4.99525 2.20747 4.89424 2.22659 4.79249 2.22499H3.29249C3.08699 2.22597 2.88371 2.26754 2.69432 2.34731C2.50494 2.42709 2.33318 2.54349 2.18892 2.68985C2.04466 2.8362 1.93073 3.00961 1.85369 3.20013C1.77665 3.39064 1.73801 3.5945 1.73999 3.79999V5.29999C1.74159 5.40174 1.72247 5.50275 1.68378 5.59687C1.6451 5.691 1.58767 5.77627 1.51499 5.84749L0.457487 6.89749C0.165289 7.19 0.00115967 7.58654 0.00115967 7.99999C0.00115967 8.41344 0.165289 8.80998 0.457487 9.10249L1.49999 10.16C1.57267 10.2312 1.6301 10.3165 1.66878 10.4106C1.70747 10.5047 1.72659 10.6057 1.72499 10.7075V12.2075C1.72597 12.413 1.76754 12.6163 1.84731 12.8056C1.92709 12.995 2.04349 13.1668 2.18985 13.3111C2.3362 13.4553 2.50961 13.5692 2.70013 13.6463C2.89064 13.7233 3.0945 13.762 3.29999 13.76H4.79999C4.90174 13.7584 5.00275 13.7775 5.09687 13.8162C5.191 13.8549 5.27627 13.9123 5.34749 13.985L6.40499 15.0425C6.69749 15.3347 7.09404 15.4988 7.50749 15.4988C7.92094 15.4988 8.31748 15.3347 8.60999 15.0425L9.65999 14C9.73121 13.9273 9.81647 13.8699 9.9106 13.8312C10.0047 13.7925 10.1057 13.7734 10.2075 13.775H11.7075C12.1212 13.775 12.518 13.6106 12.8106 13.3181C13.1031 13.0255 13.2675 12.6287 13.2675 12.215V10.715C13.2659 10.6132 13.285 10.5122 13.3237 10.4181C13.3624 10.324 13.4198 10.2387 13.4925 10.1675L14.55 9.10999C14.6953 8.96452 14.8104 8.79176 14.8887 8.60164C14.9671 8.41152 15.007 8.20779 15.0063 8.00218C15.0056 7.79656 14.9643 7.59311 14.8847 7.40353C14.8051 7.21394 14.6888 7.04197 14.5425 6.89749ZM10.635 6.64999L6.95249 10.25C6.90055 10.3026 6.83864 10.3443 6.77038 10.3726C6.70212 10.4009 6.62889 10.4153 6.55499 10.415C6.48062 10.4139 6.40719 10.3982 6.33896 10.3685C6.27073 10.3389 6.20905 10.2961 6.15749 10.2425L4.37999 8.44249C4.32532 8.39044 4.28169 8.32793 4.25169 8.25867C4.22169 8.18941 4.20593 8.11482 4.20536 8.03934C4.20479 7.96387 4.21941 7.88905 4.24836 7.81934C4.27731 7.74964 4.31999 7.68647 4.37387 7.63361C4.42774 7.58074 4.4917 7.53926 4.56194 7.51163C4.63218 7.484 4.70726 7.47079 4.78271 7.47278C4.85816 7.47478 4.93244 7.49194 5.00112 7.52324C5.0698 7.55454 5.13148 7.59935 5.18249 7.65499L6.56249 9.05749L9.84749 5.84749C9.95296 5.74215 10.0959 5.68298 10.245 5.68298C10.394 5.68298 10.537 5.74215 10.6425 5.84749C10.6953 5.90034 10.737 5.96318 10.7653 6.03234C10.7935 6.1015 10.8077 6.1756 10.807 6.25031C10.8063 6.32502 10.7908 6.39884 10.7612 6.46746C10.7317 6.53608 10.6888 6.59813 10.635 6.64999Z"
        fill="currentColor"
      ></path>
    </svg>
  )
}

export const CartIcon = ({ className }: Omit<IconProps, 'type'>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
      />
    </svg>
  )
}
export const AddToCartIcon = ({ className }: Omit<IconProps, 'type'>) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 80.000000 80.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,80.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M12 788 c-16 -16 -15 -43 1 -56 7 -6 35 -12 62 -14 l50 -3 37 -244
c21 -134 43 -250 49 -257 9 -11 65 -14 275 -14 l264 0 6 25 c13 52 2 54 -250
57 l-231 3 -3 38 -3 37 220 0 220 0 19 63 c49 159 74 257 68 272 -8 21 -35 30
-54 18 -9 -5 -32 -67 -52 -139 l-37 -129 -201 -3 c-121 -1 -202 1 -202 7 0 40
-52 326 -61 337 -15 18 -159 20 -177 2z"
        />
        <path
          d="M432 788 c-7 -7 -12 -29 -12 -49 0 -37 -1 -38 -41 -41 -80 -6 -80
-70 -1 -76 40 -3 41 -4 44 -44 6 -79 70 -79 76 0 3 40 4 41 44 44 79 6 79 70
-1 76 -40 3 -41 4 -41 41 0 39 -14 61 -40 61 -9 0 -21 -5 -28 -12z"
        />
        <path
          d="M185 134 c-50 -54 -14 -134 59 -134 79 0 106 109 35 145 -41 22 -67
18 -94 -11z"
        />
        <path
          d="M642 154 c-17 -8 -42 -58 -42 -84 0 -33 44 -70 84 -70 63 0 99 80 59
129 -18 21 -76 36 -101 25z"
        />
      </g>
    </svg>
  )
}
export const FileUploadIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-file-up', type, className)}></i>
}

export const InformationIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-information-1', type, className)}></i>
}

export const CloseIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-cross', type, className)}></i>
}

export const PictureIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-picture', type, className)}></i>
}

export const LocationIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-geolocation', type, className)}></i>
}

export const MenuIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-menu', type, className)}></i>
}

export const UserSquareIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-user-square', type, className)}></i>
}

export const ShopIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-shop', type, className)}></i>
}

export const UserCheckIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-user-tick', type, className)}></i>
}

export const ArchiveIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-archive', type, className)}></i>
}

export const ExclamationCircleIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return (
    <i
      className={cn(
        'ki-information-1 flex items-center justify-center',
        type,
        className
      )}
    ></i>
  )
}

export const CheckCircleIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-check-circle', type, className)}></i>
}

export const InfoCircleIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-information-2', type, className)}></i>
}

export const StudentIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-teacher', type, className)}></i>
}

export const MobileIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-phone', type, className)}></i>
}

export const ShieldIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-shield', type, className)}></i>
}

export const BankIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-bank', type, className)}></i>
}

export const StromIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-abstract-22', type, className)}></i>
}

export const LockIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-lock', type, className)}></i>
}

export const SuccessIcon = ({ className }: Omit<IconProps, 'type'>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5 13l4 4L19 7"
      />
    </svg>
  )
}
export const PencilIcon = ({ className }: Omit<IconProps, 'type'>) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.9422 3.55782L13.4422 1.05782C13.3841 0.999706 13.3152 0.953606 13.2393 0.922153C13.1635 0.890701 13.0821 0.874512 13 0.874512C12.9179 0.874512 12.8365 0.890701 12.7607 0.922153C12.6848 0.953606 12.6159 0.999706 12.5578 1.05782L5.05781 8.55782C4.99979 8.6159 4.95378 8.68485 4.92242 8.76072C4.89105 8.8366 4.87494 8.9179 4.875 9V11.5C4.875 11.6658 4.94085 11.8247 5.05806 11.9419C5.17527 12.0592 5.33424 12.125 5.5 12.125H8C8.0821 12.1251 8.16341 12.109 8.23928 12.0776C8.31515 12.0462 8.3841 12.0002 8.44219 11.9422L15.9422 4.44219C16.0003 4.38415 16.0464 4.31522 16.0779 4.23934C16.1093 4.16347 16.1255 4.08214 16.1255 4C16.1255 3.91787 16.1093 3.83654 16.0779 3.76067C16.0464 3.68479 16.0003 3.61586 15.9422 3.55782ZM7.74141 10.875H6.125V9.2586L11.125 4.2586L12.7414 5.875L7.74141 10.875ZM13.625 4.99141L12.0086 3.375L13 2.3836L14.6164 4L13.625 4.99141ZM15.5 8.375V15.25C15.5 15.5815 15.3683 15.8995 15.1339 16.1339C14.8995 16.3683 14.5815 16.5 14.25 16.5H1.75C1.41848 16.5 1.10054 16.3683 0.866116 16.1339C0.631696 15.8995 0.5 15.5815 0.5 15.25V2.75C0.5 2.41848 0.631696 2.10054 0.866116 1.86612C1.10054 1.6317 1.41848 1.5 1.75 1.5H8.625C8.79076 1.5 8.94973 1.56585 9.06694 1.68306C9.18415 1.80027 9.25 1.95924 9.25 2.125C9.25 2.29076 9.18415 2.44973 9.06694 2.56695C8.94973 2.68416 8.79076 2.75 8.625 2.75H1.75V15.25H14.25V8.375C14.25 8.20924 14.3158 8.05027 14.4331 7.93306C14.5503 7.81585 14.7092 7.75 14.875 7.75C15.0408 7.75 15.1997 7.81585 15.3169 7.93306C15.4342 8.05027 15.5 8.20924 15.5 8.375Z"
        fill="#1C2E40"
      />
    </svg>
  )
}

export const LightningIcon = ({ className }: Omit<IconProps, 'type'>) => {
  return (
    <svg
      width="14"
      height="20"
      viewBox="0 0 14 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.8586 9.23183C13.835 9.13166 13.7869 9.03888 13.7188 8.96174C13.6506 8.8846 13.5645 8.82549 13.468 8.78964L8.96721 7.10136L10.1125 1.37246C10.1385 1.23935 10.1204 1.10141 10.0611 0.979472C10.0017 0.85753 9.90434 0.758195 9.7836 0.696456C9.66286 0.634718 9.52531 0.613926 9.39171 0.637218C9.25812 0.660511 9.13572 0.726624 9.04299 0.82558L0.292995 10.2006C0.221928 10.2755 0.170518 10.3668 0.143357 10.4664C0.116195 10.566 0.114129 10.6708 0.137343 10.7714C0.160557 10.872 0.208328 10.9652 0.276387 11.0429C0.344447 11.1205 0.430676 11.18 0.52737 11.2162L5.02971 12.9045L3.88753 18.6271C3.86159 18.7603 3.87965 18.8982 3.93899 19.0201C3.99832 19.1421 4.09571 19.2414 4.21645 19.3031C4.3372 19.3649 4.47474 19.3857 4.60834 19.3624C4.74194 19.3391 4.86433 19.273 4.95706 19.174L13.7071 9.79902C13.7768 9.72412 13.8272 9.63323 13.8536 9.53433C13.88 9.43543 13.8817 9.33155 13.8586 9.23183ZM5.54456 16.7186L6.36253 12.6264C6.3918 12.4812 6.3686 12.3304 6.29707 12.2008C6.22553 12.0712 6.1103 11.9711 5.9719 11.9186L1.84378 10.3678L8.45471 3.28496L7.63753 7.37714C7.60825 7.52228 7.63145 7.67309 7.70298 7.80271C7.77452 7.93234 7.88975 8.03236 8.02815 8.08496L12.1532 9.63183L5.54456 16.7186Z"
        fill="#1C2E40"
      />
    </svg>
  )
}

export const ChatIcon = ({ className, type = IconType.Filled }: IconProps) => {
  return <i className={cn('ki-message-text-2', type, className)}></i>
}

export const CameraIconBlack = ({ className }: Omit<IconProps, 'type'>) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        opacity="0.2"
        d="M39 12H33L30 7.5H18L15 12H9C8.20435 12 7.44129 12.3161 6.87868 12.8787C6.31607 13.4413 6 14.2044 6 15V36C6 36.7956 6.31607 37.5587 6.87868 38.1213C7.44129 38.6839 8.20435 39 9 39H39C39.7957 39 40.5587 38.6839 41.1213 38.1213C41.6839 37.5587 42 36.7956 42 36V15C42 14.2044 41.6839 13.4413 41.1213 12.8787C40.5587 12.3161 39.7957 12 39 12ZM24 31.5C22.665 31.5 21.3599 31.1041 20.2499 30.3624C19.1399 29.6207 18.2747 28.5665 17.7638 27.3331C17.2529 26.0997 17.1192 24.7425 17.3797 23.4331C17.6401 22.1238 18.283 20.921 19.227 19.977C20.171 19.033 21.3738 18.3901 22.6831 18.1297C23.9925 17.8692 25.3497 18.0029 26.5831 18.5138C27.8165 19.0247 28.8707 19.8899 29.6124 20.9999C30.3541 22.1099 30.75 23.415 30.75 24.75C30.75 26.5402 30.0388 28.2571 28.773 29.523C27.5071 30.7888 25.7902 31.5 24 31.5Z"
        fill="#1C2E40"
      />
      <path
        d="M39 10.5H33.8025L31.2469 6.6675C31.11 6.46228 30.9245 6.29401 30.707 6.17757C30.4896 6.06114 30.2467 6.00015 30 6H18C17.7533 6.00015 17.5104 6.06114 17.293 6.17757C17.0755 6.29401 16.89 6.46228 16.7531 6.6675L14.1956 10.5H9C7.80653 10.5 6.66193 10.9741 5.81802 11.818C4.97411 12.6619 4.5 13.8065 4.5 15V36C4.5 37.1935 4.97411 38.3381 5.81802 39.182C6.66193 40.0259 7.80653 40.5 9 40.5H39C40.1935 40.5 41.3381 40.0259 42.182 39.182C43.0259 38.3381 43.5 37.1935 43.5 36V15C43.5 13.8065 43.0259 12.6619 42.182 11.818C41.3381 10.9741 40.1935 10.5 39 10.5ZM40.5 36C40.5 36.3978 40.342 36.7794 40.0607 37.0607C39.7794 37.342 39.3978 37.5 39 37.5H9C8.60218 37.5 8.22064 37.342 7.93934 37.0607C7.65804 36.7794 7.5 36.3978 7.5 36V15C7.5 14.6022 7.65804 14.2206 7.93934 13.9393C8.22064 13.658 8.60218 13.5 9 13.5H15C15.247 13.5002 15.4902 13.4393 15.7081 13.3229C15.9259 13.2064 16.1117 13.038 16.2488 12.8325L18.8025 9H29.1956L31.7512 12.8325C31.8883 13.038 32.0741 13.2064 32.2919 13.3229C32.5098 13.4393 32.753 13.5002 33 13.5H39C39.3978 13.5 39.7794 13.658 40.0607 13.9393C40.342 14.2206 40.5 14.6022 40.5 15V36ZM24 16.5C22.3683 16.5 20.7733 16.9839 19.4165 17.8904C18.0598 18.7969 17.0024 20.0854 16.378 21.5929C15.7536 23.1004 15.5902 24.7592 15.9085 26.3595C16.2269 27.9598 17.0126 29.4298 18.1664 30.5836C19.3202 31.7374 20.7902 32.5232 22.3905 32.8415C23.9908 33.1598 25.6496 32.9964 27.1571 32.372C28.6646 31.7476 29.9531 30.6902 30.8596 29.3335C31.7661 27.9767 32.25 26.3817 32.25 24.75C32.2475 22.5627 31.3775 20.4657 29.8309 18.9191C28.2843 17.3725 26.1873 16.5025 24 16.5ZM24 30C22.9616 30 21.9466 29.6921 21.0833 29.1152C20.2199 28.5383 19.547 27.7184 19.1496 26.7591C18.7523 25.7998 18.6483 24.7442 18.8509 23.7258C19.0534 22.7074 19.5535 21.7719 20.2877 21.0377C21.0219 20.3035 21.9574 19.8034 22.9758 19.6009C23.9942 19.3983 25.0498 19.5023 26.0091 19.8996C26.9684 20.297 27.7883 20.9699 28.3652 21.8333C28.9421 22.6966 29.25 23.7116 29.25 24.75C29.25 26.1424 28.6969 27.4777 27.7123 28.4623C26.7277 29.4469 25.3924 30 24 30Z"
        fill="#1C2E40"
      />
    </svg>
  )
}

type CameraSVGProps = {
  accentPathColor?: 'primary' | 'white'
  outlinePathColor?: 'primary' | 'white'
} & Omit<IconProps, 'type'>
export const CameraSVG = ({
  className,
  accentPathColor = 'primary',
  outlinePathColor = 'primary',
}: CameraSVGProps) => {
  const colorMap = {
    primary: '#f7941e',
    white: '#ffffff',
  }
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        opacity="0.2"
        d="M39 12H33L30 7.5H18L15 12H9C8.20435 12 7.44129 12.3161 6.87868 12.8787C6.31607 13.4413 6 14.2044 6 15V36C6 36.7956 6.31607 37.5587 6.87868 38.1213C7.44129 38.6839 8.20435 39 9 39H39C39.7957 39 40.5587 38.6839 41.1213 38.1213C41.6839 37.5587 42 36.7956 42 36V15C42 14.2044 41.6839 13.4413 41.1213 12.8787C40.5587 12.3161 39.7957 12 39 12ZM24 31.5C22.665 31.5 21.3599 31.1041 20.2499 30.3624C19.1399 29.6207 18.2747 28.5665 17.7638 27.3331C17.2529 26.0997 17.1192 24.7425 17.3797 23.4331C17.6401 22.1238 18.283 20.921 19.227 19.977C20.171 19.033 21.3738 18.3901 22.6831 18.1297C23.9925 17.8692 25.3497 18.0029 26.5831 18.5138C27.8165 19.0247 28.8707 19.8899 29.6124 20.9999C30.3541 22.1099 30.75 23.415 30.75 24.75C30.75 26.5402 30.0388 28.2571 28.773 29.523C27.5071 30.7888 25.7902 31.5 24 31.5Z"
        fill={colorMap[accentPathColor]}
      />
      <path
        d="M39 10.5H33.8025L31.2469 6.6675C31.11 6.46228 30.9245 6.29401 30.707 6.17757C30.4896 6.06114 30.2467 6.00015 30 6H18C17.7533 6.00015 17.5104 6.06114 17.293 6.17757C17.0755 6.29401 16.89 6.46228 16.7531 6.6675L14.1956 10.5H9C7.80653 10.5 6.66193 10.9741 5.81802 11.818C4.97411 12.6619 4.5 13.8065 4.5 15V36C4.5 37.1935 4.97411 38.3381 5.81802 39.182C6.66193 40.0259 7.80653 40.5 9 40.5H39C40.1935 40.5 41.3381 40.0259 42.182 39.182C43.0259 38.3381 43.5 37.1935 43.5 36V15C43.5 13.8065 43.0259 12.6619 42.182 11.818C41.3381 10.9741 40.1935 10.5 39 10.5ZM40.5 36C40.5 36.3978 40.342 36.7794 40.0607 37.0607C39.7794 37.342 39.3978 37.5 39 37.5H9C8.60218 37.5 8.22064 37.342 7.93934 37.0607C7.65804 36.7794 7.5 36.3978 7.5 36V15C7.5 14.6022 7.65804 14.2206 7.93934 13.9393C8.22064 13.658 8.60218 13.5 9 13.5H15C15.247 13.5002 15.4902 13.4393 15.7081 13.3229C15.9259 13.2064 16.1117 13.038 16.2488 12.8325L18.8025 9H29.1956L31.7512 12.8325C31.8883 13.038 32.0741 13.2064 32.2919 13.3229C32.5098 13.4393 32.753 13.5002 33 13.5H39C39.3978 13.5 39.7794 13.658 40.0607 13.9393C40.342 14.2206 40.5 14.6022 40.5 15V36ZM24 16.5C22.3683 16.5 20.7733 16.9839 19.4165 17.8904C18.0598 18.7969 17.0024 20.0854 16.378 21.5929C15.7536 23.1004 15.5902 24.7592 15.9085 26.3595C16.2269 27.9598 17.0126 29.4298 18.1664 30.5836C19.3202 31.7374 20.7902 32.5232 22.3905 32.8415C23.9908 33.1598 25.6496 32.9964 27.1571 32.372C28.6646 31.7476 29.9531 30.6902 30.8596 29.3335C31.7661 27.9767 32.25 26.3817 32.25 24.75C32.2475 22.5627 31.3775 20.4657 29.8309 18.9191C28.2843 17.3725 26.1873 16.5025 24 16.5ZM24 30C22.9616 30 21.9466 29.6921 21.0833 29.1152C20.2199 28.5383 19.547 27.7184 19.1496 26.7591C18.7523 25.7998 18.6483 24.7442 18.8509 23.7258C19.0534 22.7074 19.5535 21.7719 20.2877 21.0377C21.0219 20.3035 21.9574 19.8034 22.9758 19.6009C23.9942 19.3983 25.0498 19.5023 26.0091 19.8996C26.9684 20.297 27.7883 20.9699 28.3652 21.8333C28.9421 22.6966 29.25 23.7116 29.25 24.75C29.25 26.1424 28.6969 27.4777 27.7123 28.4623C26.7277 29.4469 25.3924 30 24 30Z"
        fill={colorMap[outlinePathColor]}
      />
    </svg>
  )
}

export const PlugIcon = ({ className }: Omit<IconProps, 'type'>) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.0308 3.96935C13.9611 3.89943 13.8783 3.84395 13.7872 3.8061C13.696 3.76824 13.5983 3.74876 13.4996 3.74876C13.4009 3.74876 13.3031 3.76824 13.2119 3.8061C13.1208 3.84395 13.038 3.89943 12.9683 3.96935L11.0002 5.93747L9.06269 3.99997L11.0327 2.0306C11.1736 1.8897 11.2527 1.69861 11.2527 1.49935C11.2527 1.30009 11.1736 1.10899 11.0327 0.968098C10.8918 0.827202 10.7007 0.748047 10.5014 0.748047C10.3022 0.748047 10.1111 0.827202 9.97019 0.968098L8.00019 2.93747L6.53081 1.46935C6.46105 1.39958 6.37823 1.34424 6.28707 1.30649C6.19592 1.26873 6.09822 1.2493 5.99956 1.2493C5.8003 1.2493 5.60921 1.32845 5.46831 1.46935C5.32742 1.61024 5.24826 1.80134 5.24826 2.0006C5.24826 2.19986 5.32742 2.39095 5.46831 2.53185L5.68769 2.74997L2.55581 5.88372C2.30041 6.13909 2.09781 6.44227 1.95958 6.77594C1.82136 7.10961 1.75021 7.46724 1.75021 7.82841C1.75021 8.18958 1.82136 8.54721 1.95958 8.88088C2.09781 9.21456 2.30041 9.51773 2.55581 9.7731L3.36081 10.5781L0.469563 13.4693C0.399798 13.5391 0.344457 13.6219 0.306701 13.7131C0.268945 13.8042 0.249512 13.9019 0.249512 14.0006C0.249512 14.0993 0.268945 14.197 0.306701 14.2881C0.344457 14.3793 0.399798 14.4621 0.469563 14.5318C0.610459 14.6727 0.801555 14.7519 1.00081 14.7519C1.09947 14.7519 1.19717 14.7325 1.28832 14.6947C1.37948 14.657 1.4623 14.6016 1.53206 14.5318L4.42331 11.6406L5.22831 12.4456C5.48368 12.701 5.78685 12.9036 6.12053 13.0418C6.4542 13.1801 6.81183 13.2512 7.173 13.2512C7.53417 13.2512 7.8918 13.1801 8.22547 13.0418C8.55914 12.9036 8.86232 12.701 9.11769 12.4456L12.2502 9.31247L12.4696 9.53247C12.5393 9.60224 12.6222 9.65758 12.7133 9.69533C12.8045 9.73309 12.9022 9.75252 13.0008 9.75252C13.0995 9.75252 13.1972 9.73309 13.2883 9.69533C13.3795 9.65758 13.4623 9.60224 13.5321 9.53247C13.6018 9.46271 13.6572 9.37988 13.6949 9.28873C13.7327 9.19758 13.7521 9.09988 13.7521 9.00122C13.7521 8.90256 13.7327 8.80486 13.6949 8.71371C13.6572 8.62256 13.6018 8.53974 13.5321 8.46997L12.0627 6.99997L14.0327 5.0306C14.1023 4.96082 14.1575 4.87801 14.1951 4.78689C14.2326 4.69578 14.2519 4.59815 14.2517 4.49958C14.2515 4.40102 14.2319 4.30346 14.194 4.21248C14.1561 4.1215 14.1007 4.03888 14.0308 3.96935ZM8.05581 11.3837C7.93973 11.4998 7.80191 11.592 7.65022 11.6548C7.49853 11.7177 7.33595 11.75 7.17175 11.75C7.00756 11.75 6.84497 11.7177 6.69328 11.6548C6.54159 11.592 6.40377 11.4998 6.28769 11.3837L3.61644 8.71247C3.50031 8.59639 3.40819 8.45857 3.34534 8.30688C3.28249 8.15519 3.25014 7.99261 3.25014 7.82841C3.25014 7.66422 3.28249 7.50163 3.34534 7.34994C3.40819 7.19825 3.50031 7.06043 3.61644 6.94435L6.75019 3.81247L11.1877 8.24997L8.05581 11.3837Z"
        fill="#1C2E40"
      />
    </svg>
  )
}

export const BackIcon = ({ className }: Omit<IconProps, 'type'>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M21.3749 12C21.3749 12.2984 21.2564 12.5846 21.0454 12.7955C20.8344 13.0065 20.5483 13.125 20.2499 13.125H6.46866L11.2987 17.9541C11.51 18.1654 11.6287 18.4521 11.6287 18.751C11.6287 19.0499 11.51 19.3365 11.2987 19.5478C11.0873 19.7592 10.8007 19.8779 10.5018 19.8779C10.2029 19.8779 9.91625 19.7592 9.70491 19.5478L2.95491 12.7978C2.85003 12.6933 2.76681 12.5691 2.71003 12.4324C2.65325 12.2956 2.62402 12.149 2.62402 12.001C2.62402 11.8529 2.65325 11.7063 2.71003 11.5696C2.76681 11.4328 2.85003 11.3086 2.95491 11.2041L9.70491 4.4541C9.80956 4.34945 9.93379 4.26644 10.0705 4.20981C10.2072 4.15317 10.3538 4.12402 10.5018 4.12402C10.6498 4.12402 10.7963 4.15317 10.9331 4.20981C11.0698 4.26644 11.194 4.34945 11.2987 4.4541C11.4033 4.55875 11.4863 4.68298 11.543 4.81971C11.5996 4.95644 11.6287 5.10298 11.6287 5.25097C11.6287 5.39897 11.5996 5.54551 11.543 5.68224C11.4863 5.81897 11.4033 5.9432 11.2987 6.04785L6.46866 10.875H20.2499C20.5483 10.875 20.8344 10.9936 21.0454 11.2045C21.2564 11.4155 21.3749 11.7017 21.3749 12Z"
        fill="#343330"
      />
    </svg>
  )
}

export const FrameCornerIcon = ({ className }: Omit<IconProps, 'type'>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.5 5.25H10.5C10.6989 5.25 10.8897 5.32902 11.0303 5.46967C11.171 5.61032 11.25 5.80109 11.25 6C11.25 6.19891 11.171 6.38968 11.0303 6.53033C10.8897 6.67098 10.6989 6.75 10.5 6.75H8.25V9C8.25 9.19891 8.17098 9.38968 8.03033 9.53033C7.88968 9.67098 7.69891 9.75 7.5 9.75C7.30109 9.75 7.11032 9.67098 6.96967 9.53033C6.82902 9.38968 6.75 9.19891 6.75 9V6C6.75 5.80109 6.82902 5.61032 6.96967 5.46967C7.11032 5.32902 7.30109 5.25 7.5 5.25ZM15.75 15V17.25H13.5C13.3011 17.25 13.1103 17.329 12.9697 17.4697C12.829 17.6103 12.75 17.8011 12.75 18C12.75 18.1989 12.829 18.3897 12.9697 18.5303C13.1103 18.671 13.3011 18.75 13.5 18.75H16.5C16.6989 18.75 16.8897 18.671 17.0303 18.5303C17.171 18.3897 17.25 18.1989 17.25 18V15C17.25 14.8011 17.171 14.6103 17.0303 14.4697C16.8897 14.329 16.6989 14.25 16.5 14.25C16.3011 14.25 16.1103 14.329 15.9697 14.4697C15.829 14.6103 15.75 14.8011 15.75 15ZM5.25 2.25H18.75C19.1478 2.25 19.5294 2.40804 19.8107 2.68934C20.092 2.97064 20.25 3.35217 20.25 3.75V20.25C20.25 20.6478 20.092 21.0294 19.8107 21.3107C19.5294 21.592 19.1478 21.75 18.75 21.75H5.25C4.85218 21.75 4.47064 21.592 4.18934 21.3107C3.90804 21.0294 3.75 20.6478 3.75 20.25L3.75 3.75C3.75 3.35217 3.90804 2.97064 4.18934 2.68934C4.47064 2.40804 4.85218 2.25 5.25 2.25ZM18.75 3.75H5.25L5.25 20.25H18.75V3.75Z"
        fill="#343330"
      />
    </svg>
  )
}

export const StackSampleIcon = ({ className }: Omit<IconProps, 'type'>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.12502 10.4059L11.625 16.4059C11.7384 16.4707 11.8667 16.5048 11.9972 16.5048C12.1278 16.5048 12.2561 16.4707 12.3694 16.4059L22.8694 10.4059C22.9844 10.3404 23.08 10.2455 23.1464 10.1311C23.2129 10.0167 23.248 9.88668 23.248 9.75433C23.248 9.62199 23.2129 9.49199 23.1464 9.37756C23.08 9.26312 22.9844 9.16832 22.8694 9.10277L12.3694 3.10277C12.2561 3.03798 12.1278 3.00391 11.9972 3.00391C11.8667 3.00391 11.7384 3.03798 11.625 3.10277L1.12502 9.10277C1.01004 9.16832 0.914455 9.26312 0.847967 9.37756C0.781479 9.49199 0.746457 9.62199 0.746457 9.75433C0.746457 9.88668 0.781479 10.0167 0.847967 10.1311C0.914455 10.2455 1.01004 10.3404 1.12502 10.4059ZM12 4.61308L20.9878 9.74965L12 14.8862L3.01221 9.74965L12 4.61308ZM23.1506 13.1246C23.2009 13.2103 23.2336 13.3051 23.247 13.4035C23.2603 13.5019 23.254 13.6019 23.2284 13.6979C23.2027 13.7938 23.1583 13.8837 23.0976 13.9623C23.037 14.0409 22.9613 14.1067 22.875 14.1559L12.375 20.1559C12.2617 20.2207 12.1334 20.2548 12.0028 20.2548C11.8723 20.2548 11.744 20.2207 11.6306 20.1559L1.12502 14.1559C1.03915 14.1067 0.963815 14.041 0.903325 13.9626C0.842835 13.8843 0.798371 13.7948 0.772472 13.6992C0.746573 13.6037 0.739746 13.504 0.752382 13.4058C0.765017 13.3076 0.796866 13.2129 0.846112 13.127C0.895358 13.0411 0.961035 12.9658 1.03939 12.9053C1.11775 12.8448 1.20726 12.8003 1.3028 12.7744C1.49576 12.7221 1.70159 12.7486 1.87502 12.8481L12 18.6362L22.125 12.8481C22.2105 12.7988 22.3048 12.7668 22.4027 12.754C22.5005 12.7412 22.6 12.7478 22.6952 12.7735C22.7905 12.7992 22.8798 12.8434 22.9579 12.9037C23.0361 12.9639 23.1016 13.039 23.1506 13.1246Z"
        fill="#343330"
      />
    </svg>
  )
}

export const StackIcon = ({ className }: Omit<IconProps, 'type'>) => {
  return (
    <svg
      width="24"
      height="19"
      viewBox="0 0 24 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.1249 8.3307L11.6249 14.3307C11.7382 14.3955 11.8665 14.4296 11.9971 14.4296C12.1276 14.4296 12.2559 14.3955 12.3693 14.3307L22.8693 8.3307C22.9843 8.26516 23.0798 8.17035 23.1463 8.05592C23.2128 7.94148 23.2478 7.81149 23.2478 7.67914C23.2478 7.54679 23.2128 7.4168 23.1463 7.30236C23.0798 7.18793 22.9843 7.09312 22.8693 7.02758L12.3693 1.02758C12.2559 0.962789 12.1276 0.928711 11.9971 0.928711C11.8665 0.928711 11.7382 0.962789 11.6249 1.02758L1.1249 7.02758C1.00992 7.09312 0.914332 7.18793 0.847845 7.30236C0.781357 7.4168 0.746335 7.54679 0.746335 7.67914C0.746335 7.81149 0.781357 7.94148 0.847845 8.05592C0.914332 8.17035 1.00992 8.26516 1.1249 8.3307ZM11.9999 2.53789L20.9877 7.67445L11.9999 12.811L3.01208 7.67445L11.9999 2.53789ZM23.1505 11.0495C23.2008 11.1351 23.2335 11.2299 23.2469 11.3283C23.2602 11.4267 23.2539 11.5267 23.2282 11.6227C23.2026 11.7186 23.1582 11.8085 23.0975 11.8871C23.0368 11.9658 22.9612 12.0315 22.8749 12.0807L12.3749 18.0807C12.2616 18.1455 12.1333 18.1796 12.0027 18.1796C11.8722 18.1796 11.7439 18.1455 11.6305 18.0807L1.1249 12.0807C1.03902 12.0315 0.963693 11.9658 0.903203 11.8874C0.842712 11.8091 0.798249 11.7196 0.77235 11.624C0.746451 11.5285 0.739624 11.4288 0.75226 11.3306C0.764895 11.2324 0.796744 11.1377 0.84599 11.0518C0.895236 10.9659 0.960913 10.8906 1.03927 10.8301C1.11763 10.7696 1.20714 10.7251 1.30268 10.6992C1.49564 10.6469 1.70147 10.6734 1.8749 10.7729L11.9999 16.561L22.1249 10.7729C22.2104 10.7236 22.3047 10.6916 22.4026 10.6788C22.5004 10.666 22.5998 10.6726 22.6951 10.6983C22.7904 10.724 22.8797 10.7682 22.9578 10.8285C23.036 10.8888 23.1014 10.9638 23.1505 11.0495Z"
        fill="#343330"
      />
    </svg>
  )
}

export const SparkleIcon = ({ className }: Omit<IconProps, 'type'>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M18.5231 12.0994L13.6846 10.3181L11.9034 5.47594C11.7979 5.18937 11.607 4.94206 11.3566 4.76736C11.1061 4.59267 10.8081 4.499 10.5028 4.499C10.1974 4.499 9.89937 4.59267 9.64891 4.76736C9.39846 4.94206 9.20761 5.18937 9.10213 5.47594L7.319 10.3125L2.47681 12.0938C2.19025 12.1992 1.94293 12.3901 1.76824 12.6405C1.59354 12.891 1.49988 13.189 1.49988 13.4944C1.49988 13.7997 1.59354 14.0978 1.76824 14.3482C1.94293 14.5987 2.19025 14.7895 2.47681 14.895L7.31244 16.6875L9.09369 21.5269C9.19917 21.8134 9.39002 22.0608 9.64048 22.2355C9.89093 22.4101 10.189 22.5038 10.4943 22.5038C10.7997 22.5038 11.0977 22.4101 11.3482 22.2355C11.5986 22.0608 11.7895 21.8134 11.8949 21.5269L13.6762 16.6884L18.5184 14.9072C18.8049 14.8017 19.0523 14.6109 19.227 14.3604C19.4016 14.1099 19.4953 13.8119 19.4953 13.5066C19.4953 13.2012 19.4016 12.9032 19.227 12.6527C19.0523 12.4023 18.8049 12.2114 18.5184 12.1059L18.5231 12.0994ZM13.1615 15.2812C12.9588 15.3556 12.7748 15.4732 12.6221 15.6259C12.4694 15.7786 12.3518 15.9626 12.2774 16.1653L10.4962 20.9897L8.71869 16.1616C8.64424 15.96 8.527 15.7769 8.37504 15.6249C8.22307 15.4729 8.03998 15.3557 7.83838 15.2812L3.014 13.5L7.83838 11.7188C8.03998 11.6443 8.22307 11.5271 8.37504 11.3751C8.527 11.2231 8.64424 11.04 8.71869 10.8384L10.4999 6.01406L12.2812 10.8384C12.3556 11.0411 12.4732 11.2252 12.6259 11.3778C12.7785 11.5305 12.9626 11.6481 13.1653 11.7225L17.9896 13.5037L13.1615 15.2812ZM13.4999 3.75C13.4999 3.55109 13.579 3.36032 13.7196 3.21967C13.8603 3.07902 14.051 3 14.2499 3H15.7499V1.5C15.7499 1.30109 15.829 1.11032 15.9696 0.96967C16.1103 0.829018 16.301 0.75 16.4999 0.75C16.6989 0.75 16.8896 0.829018 17.0303 0.96967C17.1709 1.11032 17.2499 1.30109 17.2499 1.5V3H18.7499C18.9489 3 19.1396 3.07902 19.2803 3.21967C19.4209 3.36032 19.4999 3.55109 19.4999 3.75C19.4999 3.94891 19.4209 4.13968 19.2803 4.28033C19.1396 4.42098 18.9489 4.5 18.7499 4.5H17.2499V6C17.2499 6.19891 17.1709 6.38968 17.0303 6.53033C16.8896 6.67098 16.6989 6.75 16.4999 6.75C16.301 6.75 16.1103 6.67098 15.9696 6.53033C15.829 6.38968 15.7499 6.19891 15.7499 6V4.5H14.2499C14.051 4.5 13.8603 4.42098 13.7196 4.28033C13.579 4.13968 13.4999 3.94891 13.4999 3.75ZM23.2499 8.25C23.2499 8.44891 23.1709 8.63968 23.0303 8.78033C22.8896 8.92098 22.6989 9 22.4999 9H21.7499V9.75C21.7499 9.94891 21.6709 10.1397 21.5303 10.2803C21.3896 10.421 21.1989 10.5 20.9999 10.5C20.801 10.5 20.6103 10.421 20.4696 10.2803C20.329 10.1397 20.2499 9.94891 20.2499 9.75V9H19.4999C19.301 9 19.1103 8.92098 18.9696 8.78033C18.829 8.63968 18.7499 8.44891 18.7499 8.25C18.7499 8.05109 18.829 7.86032 18.9696 7.71967C19.1103 7.57902 19.301 7.5 19.4999 7.5H20.2499V6.75C20.2499 6.55109 20.329 6.36032 20.4696 6.21967C20.6103 6.07902 20.801 6 20.9999 6C21.1989 6 21.3896 6.07902 21.5303 6.21967C21.6709 6.36032 21.7499 6.55109 21.7499 6.75V7.5H22.4999C22.6989 7.5 22.8896 7.57902 23.0303 7.71967C23.1709 7.86032 23.2499 8.05109 23.2499 8.25Z"
        fill="#343330"
      />
    </svg>
  )
}

export const SuccessCircleIcon = ({ className }: Omit<IconProps, 'type'>) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        opacity="0.2"
        d="M42 24C42 27.5601 40.9443 31.0402 38.9665 34.0003C36.9886 36.9604 34.1774 39.2675 30.8883 40.6298C27.5992 41.9922 23.98 42.3487 20.4884 41.6541C16.9967 40.9596 13.7894 39.2453 11.2721 36.7279C8.75474 34.2106 7.04041 31.0033 6.34587 27.5116C5.65134 24.02 6.0078 20.4008 7.37018 17.1117C8.73255 13.8226 11.0397 11.0114 13.9997 9.03355C16.9598 7.05568 20.4399 6 24 6C28.7739 6 33.3523 7.89642 36.7279 11.2721C40.1036 14.6477 42 19.2261 42 24Z"
        fill="#38A169"
      />
      <path
        d="M32.5613 18.4387C32.7007 18.5781 32.8114 18.7435 32.8868 18.9256C32.9623 19.1077 33.0012 19.3029 33.0012 19.5C33.0012 19.6971 32.9623 19.8923 32.8868 20.0744C32.8114 20.2565 32.7007 20.4219 32.5613 20.5613L22.0613 31.0613C21.9219 31.2007 21.7565 31.3114 21.5744 31.3868C21.3923 31.4623 21.1971 31.5012 21 31.5012C20.8029 31.5012 20.6077 31.4623 20.4256 31.3868C20.2435 31.3114 20.0781 31.2007 19.9388 31.0613L15.4388 26.5613C15.1573 26.2798 14.9992 25.898 14.9992 25.5C14.9992 25.102 15.1573 24.7202 15.4388 24.4387C15.7202 24.1573 16.102 23.9992 16.5 23.9992C16.8981 23.9992 17.2798 24.1573 17.5613 24.4387L21 27.8794L30.4388 18.4387C30.5781 18.2993 30.7435 18.1886 30.9256 18.1132C31.1077 18.0377 31.3029 17.9988 31.5 17.9988C31.6971 17.9988 31.8923 18.0377 32.0744 18.1132C32.2565 18.1886 32.4219 18.2993 32.5613 18.4387ZM43.5 24C43.5 27.8567 42.3564 31.6269 40.2137 34.8336C38.071 38.0404 35.0255 40.5397 31.4623 42.0156C27.8992 43.4916 23.9784 43.8777 20.1957 43.1253C16.4131 42.3729 12.9386 40.5157 10.2114 37.7886C7.4843 35.0615 5.62711 31.5869 4.8747 27.8043C4.12228 24.0216 4.50845 20.1008 5.98436 16.5377C7.46027 12.9745 9.95963 9.92903 13.1664 7.78634C16.3731 5.64366 20.1433 4.5 24 4.5C29.1701 4.50546 34.1268 6.56167 37.7826 10.2174C41.4383 13.8732 43.4945 18.83 43.5 24ZM40.5 24C40.5 20.7366 39.5323 17.5465 37.7193 14.8331C35.9062 12.1197 33.3293 10.0048 30.3143 8.75599C27.2993 7.50714 23.9817 7.18039 20.781 7.81704C17.5803 8.4537 14.6403 10.0252 12.3327 12.3327C10.0252 14.6403 8.45371 17.5803 7.81705 20.781C7.1804 23.9817 7.50715 27.2993 8.756 30.3143C10.0048 33.3293 12.1197 35.9062 14.8331 37.7192C17.5465 39.5323 20.7366 40.5 24 40.5C28.3746 40.495 32.5685 38.7551 35.6618 35.6618C38.7551 32.5685 40.495 28.3745 40.5 24Z"
        fill="#38A169"
      />
    </svg>
  )
}

export const FailCircleIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-cross-circle', type, className)}></i>
}

export const WarningExclamationIcon = ({
  className,
}: Omit<IconProps, 'type'>) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        opacity="0.2"
        d="M23.5659 23.6254H4.43405C3.05374 23.6254 2.18749 22.1805 2.85796 21.0102L12.4239 4.39941C13.113 3.19629 14.887 3.19629 15.5761 4.39941L25.142 21.0102C25.8125 22.1805 24.9462 23.6254 23.5659 23.6254Z"
        fill="#F6AD55"
      />
      <path
        d="M25.9 20.5724L16.3352 3.96163C16.0962 3.55468 15.7549 3.21725 15.3453 2.98279C14.9357 2.74834 14.472 2.625 14 2.625C13.5281 2.625 13.0643 2.74834 12.6547 2.98279C12.2451 3.21725 11.9039 3.55468 11.6649 3.96163L2.10001 20.5724C1.87004 20.966 1.74884 21.4137 1.74884 21.8696C1.74884 22.3255 1.87004 22.7732 2.10001 23.1668C2.33597 23.5762 2.67661 23.9155 3.08697 24.1498C3.49734 24.3841 3.96265 24.505 4.43517 24.5001H23.5649C24.037 24.5046 24.5019 24.3835 24.9118 24.1492C25.3218 23.9149 25.6621 23.5759 25.8978 23.1668C26.1281 22.7734 26.2497 22.3258 26.2501 21.8699C26.2505 21.414 26.1297 20.9662 25.9 20.5724ZM24.383 22.2907C24.2996 22.4329 24.1799 22.5504 24.0361 22.6312C23.8924 22.7119 23.7297 22.7529 23.5649 22.7501H4.43517C4.27032 22.7529 4.10767 22.7119 3.96391 22.6312C3.82014 22.5504 3.70043 22.4329 3.61704 22.2907C3.54152 22.1628 3.50167 22.017 3.50167 21.8685C3.50167 21.72 3.54152 21.5742 3.61704 21.4463L13.1819 4.83554C13.267 4.69398 13.3872 4.57684 13.531 4.49552C13.6747 4.4142 13.837 4.37146 14.0022 4.37146C14.1674 4.37146 14.3297 4.4142 14.4734 4.49552C14.6172 4.57684 14.7374 4.69398 14.8225 4.83554L24.3874 21.4463C24.4622 21.5746 24.5013 21.7206 24.5005 21.8691C24.4998 22.0176 24.4592 22.1632 24.383 22.2907ZM13.125 15.7501V11.3751C13.125 11.143 13.2172 10.9204 13.3813 10.7564C13.5454 10.5923 13.7679 10.5001 14 10.5001C14.2321 10.5001 14.4546 10.5923 14.6187 10.7564C14.7828 10.9204 14.875 11.143 14.875 11.3751V15.7501C14.875 15.9821 14.7828 16.2047 14.6187 16.3688C14.4546 16.5329 14.2321 16.6251 14 16.6251C13.7679 16.6251 13.5454 16.5329 13.3813 16.3688C13.2172 16.2047 13.125 15.9821 13.125 15.7501ZM15.3125 19.6876C15.3125 19.9472 15.2355 20.2009 15.0913 20.4168C14.9471 20.6326 14.7421 20.8008 14.5023 20.9002C14.2625 20.9995 13.9986 21.0255 13.744 20.9749C13.4894 20.9242 13.2555 20.7992 13.0719 20.6156C12.8884 20.4321 12.7634 20.1982 12.7127 19.9436C12.6621 19.689 12.6881 19.4251 12.7874 19.1853C12.8868 18.9455 13.055 18.7405 13.2708 18.5963C13.4867 18.452 13.7404 18.3751 14 18.3751C14.3481 18.3751 14.6819 18.5134 14.9281 18.7595C15.1742 19.0056 15.3125 19.3395 15.3125 19.6876Z"
        fill="#F6AD55"
      />
    </svg>
  )
}

export const TeacherIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-teacher', type, className)}></i>
}

export const ClearMeIcon = ({ className }: Omit<IconProps, 'type'>) => {
  return (
    <svg
      viewBox="0 0 281 88"
      focusable="false"
      preserveAspectRatio="xMidYMin meet"
      data-testid="ClearLogo"
      aria-hidden="true"
      className={className}
    >
      <g fill="currentColor">
        <path d="M10.986 46.92a2.988 2.988 0 0 0 2.985-2.99 2.988 2.988 0 0 0-2.985-2.99A2.988 2.988 0 0 0 8 43.93a2.988 2.988 0 0 0 2.986 2.99ZM24.42 46.92a2.988 2.988 0 0 0 2.985-2.99 2.988 2.988 0 0 0-2.986-2.99 2.988 2.988 0 0 0-2.985 2.99 2.988 2.988 0 0 0 2.985 2.99ZM18.916 55.741a2.988 2.988 0 0 0 2.986-2.99 2.988 2.988 0 0 0-2.986-2.99 2.988 2.988 0 0 0-2.985 2.99 2.988 2.988 0 0 0 2.985 2.99ZM28.578 59.572a2.988 2.988 0 0 0 2.986-2.99 2.988 2.988 0 0 0-2.986-2.99 2.988 2.988 0 0 0-2.985 2.99 2.988 2.988 0 0 0 2.985 2.99ZM29.17 70.015a2.988 2.988 0 0 0 2.986-2.99 2.988 2.988 0 0 0-2.985-2.99 2.988 2.988 0 0 0-2.986 2.99 2.988 2.988 0 0 0 2.986 2.99ZM18.916 38.092a2.988 2.988 0 0 0 2.986-2.99 2.988 2.988 0 0 0-2.986-2.99 2.988 2.988 0 0 0-2.985 2.99 2.988 2.988 0 0 0 2.985 2.99ZM17.698 26.505a2.988 2.988 0 0 0 2.986-2.99 2.988 2.988 0 0 0-2.986-2.99 2.988 2.988 0 0 0-2.986 2.99 2.988 2.988 0 0 0 2.986 2.99ZM28.578 34.18a2.988 2.988 0 0 0 2.986-2.99 2.988 2.988 0 0 0-2.986-2.99 2.988 2.988 0 0 0-2.985 2.99 2.988 2.988 0 0 0 2.985 2.99ZM28.964 24.144a2.988 2.988 0 0 0 2.986-2.99 2.988 2.988 0 0 0-2.986-2.99 2.988 2.988 0 0 0-2.986 2.99 2.988 2.988 0 0 0 2.986 2.99ZM39.078 26.505a2.988 2.988 0 0 0 2.985-2.99 2.988 2.988 0 0 0-2.986-2.99 2.988 2.988 0 0 0-2.985 2.99 2.988 2.988 0 0 0 2.986 2.99ZM52.094 26.505a2.988 2.988 0 0 0 2.985-2.99 2.988 2.988 0 0 0-2.985-2.99 2.988 2.988 0 0 0-2.986 2.99 2.988 2.988 0 0 0 2.986 2.99ZM61.952 24.016a2.988 2.988 0 0 0 2.985-2.99 2.988 2.988 0 0 0-2.985-2.99 2.988 2.988 0 0 0-2.986 2.99 2.988 2.988 0 0 0 2.986 2.99ZM62.629 34.385a2.988 2.988 0 0 0 2.986-2.99 2.988 2.988 0 0 0-2.986-2.99 2.988 2.988 0 0 0-2.986 2.99 2.988 2.988 0 0 0 2.986 2.99ZM72.293 38.092a2.988 2.988 0 0 0 2.986-2.99 2.988 2.988 0 0 0-2.986-2.99 2.988 2.988 0 0 0-2.986 2.99 2.988 2.988 0 0 0 2.986 2.99ZM72.293 55.741a2.988 2.988 0 0 0 2.986-2.99 2.988 2.988 0 0 0-2.986-2.99 2.988 2.988 0 0 0-2.986 2.99 2.988 2.988 0 0 0 2.986 2.99ZM62.629 59.601a2.988 2.988 0 0 0 2.986-2.99 2.988 2.988 0 0 0-2.986-2.99 2.988 2.988 0 0 0-2.986 2.99 2.988 2.988 0 0 0 2.986 2.99ZM73.622 67.336a2.988 2.988 0 0 0 2.986-2.99 2.988 2.988 0 0 0-2.986-2.99 2.988 2.988 0 0 0-2.986 2.99 2.988 2.988 0 0 0 2.986 2.99ZM52.094 67.336a2.988 2.988 0 0 0 2.985-2.99 2.988 2.988 0 0 0-2.985-2.99 2.988 2.988 0 0 0-2.986 2.99 2.988 2.988 0 0 0 2.986 2.99ZM39.078 67.336a2.988 2.988 0 0 0 2.985-2.99 2.988 2.988 0 0 0-2.986-2.99 2.988 2.988 0 0 0-2.985 2.99 2.988 2.988 0 0 0 2.986 2.99ZM17.61 67.336a2.988 2.988 0 0 0 2.987-2.99 2.988 2.988 0 0 0-2.986-2.99 2.988 2.988 0 0 0-2.986 2.99 2.988 2.988 0 0 0 2.986 2.99ZM61.952 70.015a2.988 2.988 0 0 0 2.985-2.99 2.988 2.988 0 0 0-2.985-2.99 2.988 2.988 0 0 0-2.986 2.99 2.988 2.988 0 0 0 2.986 2.99ZM45.547 75.287a2.988 2.988 0 0 0 2.986-2.99 2.988 2.988 0 0 0-2.986-2.99 2.988 2.988 0 0 0-2.985 2.99 2.988 2.988 0 0 0 2.985 2.99ZM56.272 80.002a2.988 2.988 0 0 0 2.986-2.99 2.988 2.988 0 0 0-2.986-2.99 2.988 2.988 0 0 0-2.986 2.99 2.988 2.988 0 0 0 2.986 2.99ZM34.959 80.002a2.988 2.988 0 0 0 2.985-2.99 2.988 2.988 0 0 0-2.985-2.99 2.988 2.988 0 0 0-2.986 2.99 2.988 2.988 0 0 0 2.986 2.99ZM66.877 46.92a2.988 2.988 0 0 0 2.986-2.99 2.988 2.988 0 0 0-2.986-2.99 2.988 2.988 0 0 0-2.985 2.99 2.988 2.988 0 0 0 2.985 2.99ZM80.237 46.92a2.988 2.988 0 0 0 2.985-2.99 2.988 2.988 0 0 0-2.985-2.99 2.988 2.988 0 0 0-2.986 2.99 2.988 2.988 0 0 0 2.986 2.99ZM73.62 26.505a2.988 2.988 0 0 0 2.986-2.99 2.988 2.988 0 0 0-2.986-2.99 2.988 2.988 0 0 0-2.986 2.99 2.988 2.988 0 0 0 2.986 2.99ZM45.547 18.559a2.988 2.988 0 0 0 2.986-2.99 2.988 2.988 0 0 0-2.986-2.99 2.988 2.988 0 0 0-2.985 2.99 2.988 2.988 0 0 0 2.985 2.99ZM34.876 13.98a2.988 2.988 0 0 0 2.986-2.99A2.988 2.988 0 0 0 34.876 8a2.988 2.988 0 0 0-2.986 2.99 2.988 2.988 0 0 0 2.986 2.99ZM56.302 13.98a2.988 2.988 0 0 0 2.986-2.99A2.988 2.988 0 0 0 56.302 8a2.988 2.988 0 0 0-2.986 2.99 2.988 2.988 0 0 0 2.986 2.99ZM112.72 44.001c0-8.541 6.493-15.029 14.988-15.029a14.973 14.973 0 0 1 12.99 7.27l-4.972 3.13a8.693 8.693 0 0 0-3.281-3.6 8.67 8.67 0 0 0-4.699-1.268c-5.367 0-9.298 4.204-9.298 9.497 0 5.167 3.893 9.437 9.221 9.437a8.812 8.812 0 0 0 8.306-5.406l5.164 2.772a14.767 14.767 0 0 1-5.521 6.056 14.735 14.735 0 0 1-7.895 2.174c-8.821 0-14.989-6.73-14.989-15.026M151.604 29.38v29.255h19.194v-5.487h-13.504V29.38h-5.69ZM181.913 29.38v29.255h19.68v-5.368h-14.028v-6.653h11.421v-5.332h-11.421v-6.573h14.028v-5.33h-19.68ZM223.038 29.38l-11.057 29.255h5.805l1.917-5.331h12.22l1.916 5.331h5.81L228.592 29.38h-5.554Zm2.805 7.163 4.206 11.642H221.6l4.243-11.642ZM255.887 34.59v9.665h5.771c3.725 0 5.452-2.327 5.452-4.929 0-2.866-1.846-4.73-5.452-4.73l-5.771-.006Zm-5.648-5.21h11.862c6.732 0 10.738 4.327 10.738 9.902a9.51 9.51 0 0 1-5.128 8.654l5.773 10.7h-6.335l-4.686-9.22h-6.576v9.22h-5.648V29.38Z"></path>
      </g>
    </svg>
  )
}

export const DocumentIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-document', type, className)}></i>
}

export const ClockIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-time', type, className)}></i>
}

export const WalletIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-wallet', type, className)}></i>
}

export const ReportIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-graph-up', type, className)}></i>
}

export const SupportIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-support', type, className)}></i>
}

export const HelpIcon = ({ type = IconType.Filled, className }: IconProps) => {
  return <i className={cn('ki-question', type, className)}></i>
}
